import homeClient from 'flow/api-clients/home-client';
import { getQueryParam } from 'flow/utils/browser-utils';

const { hostname, pathname, search } = window.location;
const integrationHost = getQueryParam(search, 'config');
const lowerCasePathName = pathname ? pathname.toLowerCase() : '';
const isEmbeddedCtiPath = /\/embed\/integration\/?/.test(lowerCasePathName);

export function isIntegration() {
    return isEmbeddedCtiPath;
}

export function getIntegrationHost() {
    return integrationHost || '';
}

export function setCTIApiHost() {
    const isLocalhost = hostname.includes('localhost');
    if (!isLocalhost) {
        const apiHost = 'https://cti.telavox.com';
        homeClient.apiHost = apiHost;
        homeClient.endpoint = apiHost + homeClient.apiPath;
    }
}
